import axios from "axios";
import { logicType } from "schemas/elements";
import api from "../api";

/**
 * Gets shared names
 *
 */
const getSharedNames = async () => {
	const req = await api.request({
		url: "bls/core",
		method: "GET",
	});
	const sharedNames = req.data?.map((item: { data: { name: string } }) => {
		const { name } = item.data;
		return { value: `${name}/true`, label: name };
	});
	const sortedNames = [...sharedNames].sort((a, b) => {
		return a.label.toLowerCase().localeCompare(b.label.toLowerCase());
	});
	return Promise.resolve(sortedNames);
};

/**
 * Gets unshared names
 *
 */
const getUnsharedNames = async () => {
	try {
		const req = await api.request({
			url: "bls/logic",
			method: "GET",
		});
		const unsharedNames = req.data?.map(
			(item: { data: { name: string } }) => {
				const { name } = item.data;
				return { value: `${name}/false`, label: name };
			}
		);
		const sortedNames = [...unsharedNames].sort((a, b) => {
			return a.label.toLowerCase().localeCompare(b.label.toLowerCase());
		});
		return Promise.resolve(sortedNames);
	} catch (error) {
		if (error && axios.isAxiosError(error))
			console.error(`Error: ${error.message}`);
		return [];
	}
};

/**
 *
 * Gets single logic
 * @param logic Business logic to retrieve
 * @param shared Is business logic shared
 */
const getLogic = async (logic: string, shared: boolean) => {
	const req = await api.request({
		url: `bls/${shared ? "core" : "logic"}/${logic}`,
		method: "GET",
	});

	if (req.data[0].data.parameters === undefined) {
		return Promise.resolve({} as logicType["params"]);
	} else if (typeof req.data[0].data.parameters === "string") {
		// Code to work with legacy string parameters

		if (
			req.data[0].data.parameters
				.replace("[", "")
				.replace("]", "")
				.trim() === ""
		) {
			return Promise.resolve({} as logicType["params"]);
		}

		const parsed: logicType["params"] = JSON.parse(
			req.data[0].data.parameters
				.replace("[", "")
				.replace("]", "")
				.replace(";", "")
				.replace(/'/g, `"`)
		);
		return Promise.resolve(parsed);
	} else {
		return Promise.resolve(
			req.data[0].data.parameters as logicType["params"]
		);
	}
};

// /**
//  * Gets all names
//  *
//  */
// const getAllNames = async () => {
// 	const sharedNames = await getSharedNames();
// 	const unsharedNames = await getUnsharedNames();
// 	const allNames = [...sharedNames, ...unsharedNames].sort((a, b) => {
// 		return a.label.toLowerCase().localeCompare(b.label.toLowerCase());
// 	});
// 	return Promise.resolve(allNames);
// };

export default { getSharedNames, getUnsharedNames, getLogic };
